// removed by extract-text-webpack-plugin
module.exports = {"changePassword":"changePassword___3BOGX"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ChangePassword.module.less
// module id = 742
// module chunks = 0